import React, {useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import FormButton from "../../../components/forms/FormButton";
import {Title} from "../../../components/components";
import ZoneForm from "../../../components/zones/ZoneForm";
import { useGetZoneQuery, useUpdateZoneMutation } from '../../../api/zoneApiSlice';

function EditZone(props) {
  const history = useHistory();
  const { zoneId } = useParams();
  const {data: zone, isSuccess} = useGetZoneQuery(zoneId)
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [updateZone] = useUpdateZoneMutation()

  const goToZone = () => history.push(`/zones/${zoneId}`)

  const submitProps = {
    handleSubmit: (data) => {
      updateZone({...data, key: zoneId }).unwrap()
        .then(goToZone)
        .catch(error => {})
    },
    errors: {}
  }

  if(!isSuccess) { return (<></>) }
  return (
    <>
      <Title
        main={t("menu.zones")}
        sub={zone.name}
        group={false}
        onBack={goToZone}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToZone} />
      </Title>
      <ZoneForm zone={zone} {...submitProps} setSubmitButtonProps={setSubmitButtonProps} />
    </>
  )
}

export default EditZone
